import { defineComponent, inject, provide, reactive, toRefs } from 'vue'
import { omit } from 'lodash-unified'
import dayjs from 'dayjs'
import customParseFormat from 'dayjs/plugin/customParseFormat.js'
import advancedFormat from 'dayjs/plugin/advancedFormat.js'
import localeData from 'dayjs/plugin/localeData.js'
import weekOfYear from 'dayjs/plugin/weekOfYear.js'
import weekYear from 'dayjs/plugin/weekYear.js'
import dayOfYear from 'dayjs/plugin/dayOfYear.js'
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter.js'
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore.js'
import {
  PICKER_BASE_INJECTION_KEY,
  ROOT_COMMON_PICKER_INJECTION_KEY,
} from '@zoryn/components/time-picker'
import { useNamespace } from '@zoryn/hooks'
import { isUndefined } from '@zoryn/utils'
import { UPDATE_MODEL_EVENT } from '@zoryn/constants'
import { datePickerPanelProps } from './props/date-picker-panel'
import { ROOT_PICKER_INJECTION_KEY } from './constants'
import { getPanel } from './panel-utils'
import { useCommonPicker } from '../../time-picker/src/composables/use-common-picker'

dayjs.extend(localeData)
dayjs.extend(advancedFormat)
dayjs.extend(customParseFormat)
dayjs.extend(weekOfYear)
dayjs.extend(weekYear)
dayjs.extend(dayOfYear)
dayjs.extend(isSameOrAfter)
dayjs.extend(isSameOrBefore)

export default defineComponent({
  name: 'ZDatePickerPanel',
  install: null,
  inheritAttrs: false,
  props: datePickerPanelProps,
  emits: [
    UPDATE_MODEL_EVENT,
    'calendar-change',
    'panel-change',
    'visible-change',
    'clear',
  ],
  setup(props, { slots, emit, attrs }) {
    const ns = useNamespace('picker-panel')
    const pickerInjection = inject(PICKER_BASE_INJECTION_KEY, undefined)
    if (isUndefined(pickerInjection)) {
      const _props = reactive({
        ...toRefs(props),
      })
      provide(PICKER_BASE_INJECTION_KEY, {
        props: _props,
      })
    }

    provide(ROOT_PICKER_INJECTION_KEY, {
      slots,
      pickerNs: ns,
    })
    const {
      parsedValue,
      onCalendarChange,
      onPanelChange,
      onSetPickerOption,
      onPick,
    } = inject(
      ROOT_COMMON_PICKER_INJECTION_KEY,
      () => useCommonPicker(props, emit),
      true
    )

    return () => {
      const Component = getPanel(props.type)
      return (
        <Component
          {...omit(attrs, 'onPick')}
          {...props}
          parsedValue={parsedValue.value}
          onSet-picker-option={onSetPickerOption}
          onCalendar-change={onCalendarChange}
          onPandr-change={onPanelChange}
          onClear={() => emit('clear')}
          onPick={onPick}
        >
          {slots}
        </Component>
      )
    }
  },
})
